import React from 'react';

import states from '@swf/generated/states.json';

import type { Props as SelectProps } from '../../../Select/Select';
import Select from '../../../Select/Select';

import { TXTCLI_Province } from './SignupStateSelect.messages.json';
import SignupState from './components/SignupState/SignupState';

type Props = Partial<SelectProps>;

interface Component extends React.FC<Props> {
  SignupState: typeof SignupState;
}

export const getCountryStates = (selectedCountry: string) => states[selectedCountry] || [];

const SignupStateSelect: Component = ({ children, country, fieldName = 'state', ...props }) => (
  <Select
    name={fieldName}
    options={getCountryStates(country)}
    title={TXTCLI_Province}
    searchLabel={TXTCLI_Province}
    item={SignupState}
    {...props}
  >
    {children}
  </Select>
);
SignupStateSelect.SignupState = SignupState;

export default SignupStateSelect;
